<template>
  <portal to="print-dialog-container">
    <div class="m-3 p-3 print-dialog-content tw-w-[400px]">
      <component :is="dataComponent" :options="dataOptions" v-bind="$attrs" />
    </div>
  </portal>
</template>
<script setup lang="ts">
import { onMounted, onUnmounted, type Component } from "vue";

defineProps<{
  dataComponent: Component;
  dataOptions: Record<string, unknown>;
}>();
onMounted(() => {
  document.body.style.overflow = "hidden";
});

onUnmounted(() => {
  if (document.body.style.overflow === "hidden") {
    document.body.style.overflow = "";
  }
});
</script>
<style>
.print-dialog-content {
  background-color: white;
}
</style>
